module.exports = __webpack_public_path__ + "static/img/Banner_600x300_prenatal-paternity-test.70c6228.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reproductive/Banner_600x300_prenatal-paternity-test.jpg
// module id = SRjx
// module chunks = 0